import { action, thunk, thunkOn } from 'easy-peasy';
import * as settingsService from '../../services/settings';

const settingsModel = {
  policyTypeList: [],
  configData: {},

  setConfigData: action((state, payload) => {
    state.configData = payload;
  }),

  getConfigData: thunk(async (actions, payload) => {
    await settingsService
      .getConfigData(payload)
      .then(function (response) {
        actions.setConfigData(response.data.data.config);
      })
      .catch(function (error) {
        actions.setConfigData({});
        console.log(error);
      });
  }),

  setPolicyTypeList: action((state, payload) => {
    state.policyTypeList = payload;
  }),

  addUpdatePortalConfig: thunk(async (actions, payload) => {
    return await settingsService.addUpdatePortalConfig(payload);
  }),

  updatePreferences: thunk(async (actions, payload) => {
    return await settingsService.setPreferences(payload);
  }),
  updateEntityRules: thunk(async (actions, payload) => {
    return await settingsService.setEntityRules(payload);
  }),
  updatePACheckRules: thunk(async (actions, payload) => {
    return await settingsService.setPACheckRules(payload);
  }),
  updateAllowedDomains: thunk(async (actions, payload) => {
    return await settingsService.setAllowedDomains(payload);
  }),

  getPolicyTypeList: thunk(async (actions, payload) => {
    await settingsService
      .getPolicyTypes(payload)
      .then(function (response) {
        actions.setPolicyTypeList(response?.data?.data);
      })
      .catch(function (error) {
        actions.setPolicyTypeList([]);
      });
  }),

  onPreferenceUpdate: thunkOn(
    // targetResolver:
    (actions) => [
      actions.updatePreferences,
      actions.updateEntityRules,
      actions.updatePACheckRules,
      actions.updateAllowedDomains
    ],
    // handler:
    async (actions, target, { getStoreActions }) => {
      if (target?.result) {
        const storeActions = getStoreActions();
        storeActions.customize.getConfigData();
      }
    },
  ),
  setVendorList: action((state, payload) => {
    state.vendorList = payload;
  }),
  getVendorList: thunk(async (actions) => {
    await settingsService
      .getVendors()
      .then((response) => {

        //Sort the response
        const items = response.data.data.sort(
          (a, b) => a.sort_index - b.sort_index,
        );

        actions.setVendorList(items);
      })
      .catch(function (error) {
        console.log('Error', error);
        actions.setVendorList([]);
      });
  }),
};

export default settingsModel;
